<template>
  <div
    class="timer section flex items-center justify-center"
    :style="sectionStyle"
  >
    <div class="container full-width">
      <div class="row items-center">
        <div
          class="title col"
          :style="titleStyle"
        >
          <template v-if="title">{{ title }}</template>
        </div>
        <div
          v-if="timerDateTime"
          class="flex items-center"
        >
          <q-icon
            v-if="timerDateTimeIconEnabled"
            :name="timerDateTimeIcon"
            :style="{ color: titleFontColor }"
            class="q-mr-sm"
          />
          <template v-if="showTimerLabels">
            <template v-for="(value, key) in countdown">
              <span
                :key="key"
                class="timer-part"
                :style="titleStyle"
              >
                <span
                  class="timer-value"
                  :style="titleStyle"
                >
                  {{ value }}
                </span>
                <span
                  class="timer-label"
                  :style="sublabelStyle"
                >
                  {{ key }}
                </span>
              </span>
            </template>
          </template>
          <span
            v-else
            :style="titleStyle"
          >
            {{ timer }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDateTz } from 'common/helpers/date';
import { format } from 'quasar';
import backgroundMixin from './mixins/backgroundMixin';
import sublabelMixin from './mixins/sublabelMixin';
import titleMixin from './mixins/titleMixin';

export default {
  name: 'TimerSection',
  mixins: [titleMixin, sublabelMixin, backgroundMixin],
  props: {
    timerDateTime: {
      type: Number,
      default: undefined,
    },
    timerDateTimeIcon: {
      type: String,
      default: undefined,
    },
    timerDateTimeIconEnabled: {
      type: Boolean,
      default: false,
    },
    showTimerLabels: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      countdown: {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
      },
    };
  },
  computed: {
    timer() {
      return Object.values(this.countdown).join(':');
    },
  },
  watch: {
    timerDateTime: {
      immediate: true,
      handler() {
        if (!this.timerDateTime) {
          return;
        }
        this.countDownTimer();
      },
    },
  },
  methods: {
    countDownTimer() {
      const countDownDate = getDateTz(this.timerDateTime);
      let now = getDateTz(Date.now() / 1000);
      const { pad } = format;

      if (Math.floor(countDownDate.unix() - now.unix()) > 0) {
        setTimeout(() => {
          now = getDateTz(Date.now() / 1000);
          const distance = countDownDate.unix() - now.unix();

          this.countdown.days = pad(Math.floor(distance / (60 * 60 * 24)), 2);
          this.countdown.hours = pad(Math.floor((distance % (60 * 60 * 24)) / (60 * 60)), 2);
          this.countdown.minutes = pad(Math.floor((distance % (60 * 60)) / (60)), 2);
          this.countdown.seconds = pad(Math.floor(distance % 60), 2);

          this.countDownTimer();
        }, 1000);
      } else {
        this.countdown.days = '00';
        this.countdown.hours = '00';
        this.countdown.minutes = '00';
        this.countdown.seconds = '00';
      }
    },
  },
};
</script>
